export default {
  documentTypes: [{
    type: 'quoteDocument',
    text: 'Quote',
  },
  {
    type: 'purchaseOrderDocument',
    text: 'Purchase Order',
  },
  {
    type: 'billDocument',
    text: 'Bill',
  },
  {
    type: 'receiptDocument',
    text: 'Petty Cash',
  },
  {
    type: 'pettyCashAdvanceDocument',
    text: 'Petty Cash Advance',
  },
  {
    type: 'chequeDocument',
    text: 'Cheque',
  },
  {
    type: 'perDiemDocument',
    text: 'Per Diem',
  },
  {
    type: 'expenseDocument',
    text: 'Expense',
  },
  {
    type: 'billReceiptDocument',
    text: 'Receipt',
  },
  {
    type: 'proofOfPaymentDocument',
    text: 'Proof of Payment (Spend)',
  },
  {
    type: 'proofOfPaymentBillDocument',
    text: 'Proof of Payment (Bill)',
  },
  {
    type: 'contractDocument',
    text: 'Contract',
  },
  {
    type: 'payrollDocument',
    text: 'Payroll',
  },
  {
    type: 'budgetDocument',
    text: 'Budget',
  },
  {
    type: 'creditNoteDocument',
    text: 'Credit Note',
  },
  {
    type: 'supportingDocument',
    text: 'Supporting Documents',
  },
  {
    type: 'timeSheetDocument',
    text: 'TimeSheet Document',
  },
  {
    type: 'crewTopSheetDocument',
    text: 'Crew Top Sheet Document',
  },
  {
    type: 'dealMemoDocument',
    text: 'Deal Memo Document',
  },
  {
    type: 'otherDocument',
    text: 'Other',
  },
  {
    type: 'budgetDocument',
    text: 'Budget',
  },
  ],
};
